var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowDiagonalRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  className: "arrowDiagonalRight_svg__svg-safari-fix",
  viewBox: "0 0 24 24",
  "aria-hidden": props["aria-label"] || props["aria-labelledby"] ? undefined : true
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m18.597 14.891.043-8.598a1 1 0 0 0-.29-.714 1 1 0 0 0-.714-.29l-8.507.092a.987.987 0 0 0-.983 1.011.987.987 0 0 0 1.012.983l6.045-.064-9.623 9.624a1.003 1.003 0 0 0 0 1.414 1.003 1.003 0 0 0 1.414 0l9.638-9.638-.036 6.173a.993.993 0 0 0 .99 1.004.987.987 0 0 0 .997-.997z"
})));
export default SvgArrowDiagonalRight;